import { Button, Collapse } from '@mui/material';
import React, { useEffect, useState } from 'react';
import './CustomAccordion.scss';

interface CustomAccordionProps {
    title: string,
    defaultOpen: boolean,
    className?: string,
    contentClassName?: string,
    open?: boolean,
    defaultHorizontalOpen?: boolean,
    horizontalOpen?: boolean,
    showHorizontalCollapseButton?: boolean,
    disableHideButton?: boolean,
    onOpenChange?: (isOpen: boolean) => void,
    onHorizontalOpenChange?: (isOpen: boolean) => void,
}

const CustomAccordion: React.FunctionComponent<CustomAccordionProps> = (props) => {
    let [expand, setExpanded] = useState(props.defaultOpen);
    let [horizontalExpand, setHorizontalExpanded] = useState(props.defaultHorizontalOpen ? props.defaultHorizontalOpen : false);

    useEffect(() => {
        if (props.open !== undefined) {
            setExpanded(props.open);
        }
    }, [props.open])

    return (
        <div className={"accordion-wrapper " + props.className} >
            {
                !props.disableHideButton &&
                <Button
                    variant="contained"
                    className="accordion-collapse-button"
                    onClick={() => {
                        setExpanded(!expand);

                        if (props.onOpenChange) {
                            props.onOpenChange(!expand)
                        }
                    }}
                    tabIndex={-1}
                >
                    {
                        expand &&
                        <i className="fa fa-chevron-up" aria-hidden="true"></i>
                    }
                    {
                        !expand &&
                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                    }
                </Button>
            }
            {
                props.showHorizontalCollapseButton &&
                <Button
                    variant="contained"
                    className="accordion-horizontal-collapse-button"
                    onClick={() => {
                        setHorizontalExpanded(!horizontalExpand);

                        if (props.onHorizontalOpenChange) {
                            props.onHorizontalOpenChange(!horizontalExpand)
                        }
                    }}
                    tabIndex={-1}
                >
                    {
                        horizontalExpand &&
                        <i className="fa fa-chevron-left" aria-hidden="true"></i>
                    }
                    {
                        !horizontalExpand &&
                        <i className="fa fa-chevron-right" aria-hidden="true"></i>
                    }
                </Button>
            }


            <span className="accordion-title">{props.title}</span>
            <div className={"accordion-content " + (props.contentClassName ? props.contentClassName : "")}>
                <Collapse orientation="vertical" in={expand}>
                    {props.children}
                </Collapse>
            </div>
        </div>
    )
};

export default CustomAccordion;